import {
  Dumbbell, Footprints, Move, Apple, Flower2, HeartHandshake, Scale, House,
  RotateCcw, Sparkles, Heart, MessageCircle,
} from "lucide-react";

export const ICONS = {
  Dumbbell, Footprints, Move, Apple, Flower2, HeartHandshake, Scale, House,
  RotateCcw, Sparkles, Heart, MessageCircle,
};

export function Icon({ name, className }) {
  const Cmp = ICONS[name] || MessageCircle;
  return <Cmp className={className} strokeWidth={1.75} />;
}
